/**
 * SweetAlert integration
 * https://sweetalert2.github.io/
 * @author Virgilio Vázquez J. <virgilio.vazquez@jbge.com.mx>
 */

import Swal from "sweetalert2/dist/sweetalert2.js";

const sweetMixin = {
  methods: {
    /**
     * Show sweetalert popup
     * @param  {Object|String} arg   The alert payload
     * @return {Promise}             A sweetalert promise
     */
    $fire(arg = {}) {
      return Swal.fire({
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        ...arg,
        icon: arg.icon || arg.type,
      });
    },

    $fireErrorResponse(error, opts = {}) {
      let html;
      let icon = "error";
      let title = "Ha ocurrido un error.";
      let wrapped;

      try {
        html = error.htmlString();
        wrapped = JSON.parse(JSON.stringify(error.wrapped));
        if (wrapped.status < 500) {
          icon = "warning";
          title = "Validación";
        }
      } catch (err) {
        html = error.toString();
      }

      return this.$fire({
        icon,
        title,
        html,
        confirmButtonColor: "#3085d6",
        ...opts,
      });
    },

    /**
     * @author José Luis R. <jose.ruiz@jbge.com.mx>
     * @param title
     * @param method Method to run if user clicks confirm
     * @param callback Next thing to do after confirm click. Ex. Run successMessage
     */

    $confirmMessage(arg = {}, method, dismissedCallback = () => {}) {
      return Swal.fire({
        title: "Aviso",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        preConfirm: (res) => method(res),
        allowOutsideClick: () => !Swal.isLoading() || false,
        ...arg,
      }).then((response) => {
        if (!response.value) {
          return dismissedCallback(response);
        }
        return null;
      });
    },
    $loadingMessage(arg = {}) {
      return Swal.fire({
        title: "Guardado cambios",
        html: "Por favor espere",
        icon: "info",
        allowOutsideClick: false,
        showCancelButton: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
        ...arg,
      });
    },
    $successMessage(arg = {}) {
      return Swal.fire({
        icon: "success",
        title: "Exitoso",
        showConfirmButton: false,
        timer: 1500,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        ...arg,
      });
    },
    $alertMessage(arg = {}) {
      return Swal.fire({
        icon: "warning",
        title: "Alerta",
        showConfirmButton: false,
        timer: 1500,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        ...arg,
      });
    },
  },
};

export default {
  install(Vue) {
    Vue.mixin(sweetMixin);
  },
};



// WEBPACK FOOTER //
// ./src/plugins/sweetAlert.js